import { useInterviewContext } from "../InterviewContext";
import RatingItem from "./RatingItem";
import { useTranslation } from "react-i18next";
import "../Interview.scss";
import "../../styles/forms.scss";
import { useEffect } from "react";
import { useGeneralContext } from "../../General/Context";

const GlobalClassification = () => {
  const {
    interview,
    setInterview,
    errors,
    docOnlineLanguages,
    calculateGlobalRating
  } = useInterviewContext();
  const { userInformation } = useGeneralContext();
  const { t } = useTranslation();

  function onChange({ target }) {
    setInterview((prevInterview) => ({
      ...prevInterview,
      [`${target.name}`]: target.value
    }));
  }

  function onChangeDOCOnlineLanguage({ target }) {
    setInterview((prevInterview) => ({
      ...prevInterview,
      [`${target.name}`]: Number(target.value)
    }));
  }

  const onChangeAutosendDocOnline = (e) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      autosendDocOnline: e.target.checked
    }));
  };

  function setRating(rating, skillId) {
    let _skills = [...interview.skills];
    for (let skill of _skills) {
      if (skill.id === skillId) {
        skill.rating = rating;
        break;
      }
    }
    setInterview({ ...interview, skills: _skills });
    setInterview({
      ...interview,
      globalRating: calculateGlobalRating(interview.skills)
    });
  }

  return (
    <div className="global-classification">
      <div className="col-6">
        <h1>{t("Personal Skills and Competences")}</h1>
        {errors.rating && <div className="error-msg">{errors.rating}</div>}
        {interview.skills.map((skill) => (
          <div className="row ranking" key={skill.id}>
            <div className="col">{t(skill.personalSkill)}</div>
            <div className="col text-end ">({skill.rating})</div>
            <div className="col aling-center">
              <RatingItem onChange={setRating} skill={skill} />
            </div>
          </div>
        ))}
        <div
          style={{ borderBottom: "1px solid #bebebe", borderWidth: "medium" }}
        />
        <div className="row mt-2 align-items-center">
          <div className="col">
            <strong style={{ marginRight: "12px", fontWeight: 600 }}>
              {t("Global Rating")}
            </strong>{" "}
          </div>
          <div className="col text-end">
            {Number(interview.globalRating).toFixed(1) || "0.0"}
          </div>
          <div className="col">
            <RatingItem
              onChange={setRating}
              skill={{ id: 0, rating: interview.globalRating }}
            />
          </div>
        </div>
      </div>
      <h1 className="mt-4">{t("Write feedback")}</h1>
      <div className="mb-3">
        <label htmlFor="notes" className="form-label">
          {t("Global notes")}
        </label>
        <textarea
          className="form-control"
          id="notes"
          rows="3"
          name="notes"
          value={interview.notes}
          onChange={onChange}
          placeholder={t("Add global notes...")}
        />
      </div>
      <div className="col-md-4">
        <div className="label-wrapper">
          <label>
            {t("In which language should the Doc Online be generated?")}
          </label>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }}
      >
        <div className="form-group">
          <select
            id="docOnlineLanguageId"
            name="docOnlineLanguageId"
            className="form-select"
            onChange={onChangeDOCOnlineLanguage}
            value={interview.docOnlineLanguageId}
            title={t("Selecione um item da lista.")}
            style={{ width: "200px" }}
          >
            {docOnlineLanguages.map((item) => (
              <option key={item.id} value={item.id}>
                {t(item.languageDescription)}
              </option>
            ))}
          </select>
        </div>
        {interview.interviewOrderSequence <= 1 && (
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="checkbox"
              onChange={onChangeAutosendDocOnline}
              name="autosendDocOnline"
              value={interview.autosendDocOnline}
              checked={interview.autosendDocOnline}
              style={{ marginLeft: "20px" }}
            />
            <label>{t("Automatic send")}</label>
          </div>
        )}
      </div>
    </div>
  );
};

export default GlobalClassification;
